module.exports = __webpack_public_path__ + "img/htcm_08.2fec020d.jpg";